<template>
  <div class="about-us-page">
    <div class="header-wrap">
      <nav-bar class="about-nav-bar" :class="{ 'white-bg': changeNavBarBg }" />
      <div
        class="fixed-settle-wrap"
        :class="{ 'show-fixed-settle': changeNavBarBg }"
      >
        <div class="cont-wrap">
          <p>探索知识，收获梦想</p>
          <button @click="jumpSettleIn">立即入驻</button>
        </div>
      </div>
      <div class="top-cont">
        <!-- 介绍 -->
        <div class="intro">
          <p class="title header-info-wrap">
            探索知识，收获梦想
            <button class="settle-in-btn" @click="jumpSettleIn">
              立即入驻
            </button>
          </p>
          <p class="info">
            欢迎来到魔果云课，一个致力于为全球教师和学生打造充满活力与互动的在线学习社区。让我们一起探索知识的无限可能，共同收获成长与梦想
          </p>
        </div>
        <div class="info-list">
          <div class="story info-item">
            <span class="index">01</span>
            <p class="title">品牌故事：播种知识，结果硕硕</p>
            <p class="text">
              魔果云课的名字灵感来自于"恶魔果实"，寓意着教师在这里播下知识的种子，让学生们收获丰硕的果实。这个比喻不仅体现了我们对知识传递的热情，也象征着每个学习者在这里可以获得独特的技能和成长
            </p>
          </div>
          <div class="mission info-item">
            <span class="index">02</span>
            <p class="title">我们的使命</p>
            <p class="text">
              为教师提供最好用和高效的软件，让他们打造出最令人兴奋的课程。
              为学生提供最优质的学习体验，让他们在充满活力的互动中掌握新知识
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="class-features">
      <p class="title">教育培训全场景解决方案</p>
      <div class="cont-wrap">
        <ul class="tab-list">
          <li
            @mouseenter="handleMouseEnter(item.id)"
            v-for="item in tablist"
            :key="item.id"
            class="tab-item"
            :class="{ 'is-active': activeId === item.id }"
          >
            <p class="tab-name">{{ item.name }}</p>
            <p class="tab-info">{{ item.info }}</p>
          </li>
        </ul>
        <div class="img-wrap">
          <img
            v-for="image in tablist"
            :key="'image' + image.id"
            :src="image.image"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="ai-cont">
      <div class="cont-wrap">
        <p class="title">AI智能一站式学习平台</p>
        <ul class="info-wrap">
          <li class="info-item">
            <img
              class="icon"
              src="../../assets/images/about/icon1.png"
              alt=""
            />
            <p class="name">智能课程设计</p>
            <p class="info">
              通过AI技术,我们能够为教师提供智能化的教学工具,帮助他们自动化课程管理,分析学习数据,并提供个性化的教学方案
            </p>
          </li>
          <li class="info-item">
            <img
              class="icon"
              src="../../assets/images/about/icon2.png"
              alt=""
            />
            <p class="name">个性化学习体验</p>
            <p class="info">
              对于学生来说,AI技术可以推荐最适合他们的学习路径,提供即时反馈和答疑,大幅提升学习效率和效果
            </p>
          </li>
          <li class="info-item">
            <img
              class="icon"
              src="../../assets/images/about/icon3.png"
              alt=""
            />
            <p class="name">全面的数据分析</p>
            <p class="info">
              我们利用AI技术对教学过程进行全面的数据分析,为教师和学生提供宝贵的洞见,不断优化教学质量和学习体验
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="user-cont">
      <div class="cont-wrap">
        <p class="title">多元参与 共筑教育未来</p>
        <ul class="user-list">
          <li class="user-item">
            <img src="../../assets/images/about/user1.png" alt="" />
            <p class="name">老师加入</p>
            <p class="info">
              成为魔果云课的讲师,尽情展示您的专业技能,和更多学习者分享知识
            </p>
            <button class="join-btn" @click="jumpSettleIn">立即加入</button>
            <!-- <div class="hover-btn-wrap">
              <button @click="jumpSettleIn">立即加入</button>
            </div> -->
          </li>
          <!-- <li class="user-item">
            <img src="../../assets/images/about/user2.png" alt="" />
            <p class="name">学生加入</p>
            <p class="info">
              加入魔果云课,探索广阔的知识领域,实现您的学习目标,收获属于自己的成就感
            </p>
            <div class="hover-btn-wrap">
              <button @click="jumpSettleIn">立即加入</button>
            </div>
          </li> -->
          <li class="user-item partner">
            <img src="../../assets/images/about/user3.png" alt="" />
            <p class="name">合作伙伴</p>
            <p class="info">
              如果您是教育机构或企业,欢迎与我们达成合作,共同推动在线教育事业的发展
            </p>
            <button class="join-btn" @click="jumpSettleIn">立即加入</button>
            <!-- <div class="hover-btn-wrap">
              <button @click="jumpSettleIn">立即加入</button>
            </div> -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar } from "@saas/components/src";
export default {
  data: function () {
    return {
      changeNavBarBg: false,
      activeId: 1,
      tablist: [
        {
          id: 1,
          name: "多样化场景",
          info: "1对1在线授课、小班课以及大班课等多种教学场景",
          image: require("../../assets/images/about/tab-image1.png"),
        },
        {
          id: 2,
          name: "丰富教学工具",
          info: "上课小工具、课件白板、桌面分享、举手上台等多种实用功能",
          image: require("../../assets/images/about/tab-image2.png"),
        },
        {
          id: 3,
          name: "版权保护",
          info: "采用防录屏系统、课程水印以及版权声明等措施，有效保护教学内容版权",
          image: require("../../assets/images/about/tab-image3.png"),
        },
      ],
    };
  },
  mounted() {
    // 监听滚动
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleMouseEnter(id) {
      this.activeId = id;
      let elImageWrap = document.querySelector(".img-wrap");
      if (elImageWrap) {
        elImageWrap.scrollTop = 541 * (id - 1);
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement?.scrollTop || 0;
      let height = document.querySelector(".header-info-wrap")?.offsetTop || 0;
      if (scrollTop > height) {
        this.changeNavBarBg = true;
      } else {
        this.changeNavBarBg = false;
      }
    },
    jumpSettleIn() {
      if (!this.isAuthenticated) {
        this.$loginDialog({
          isShowEquity: true,
        });
      } else {
        this.$router.push("/settle-in");
      }
    },
  },
  computed: {
    activeImage() {
      return this.tablist.filter((item) => {
        return item.id === this.activeId;
      })[0].image;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  components: {
    "nav-bar": NavBar,
  },
};
</script>

<style scoped lang="scss">
$fixed-settle-height: 80px;
.fixed-settle-wrap {
  &.show-fixed-settle {
    display: flex;
  }
  position: fixed;
  top: $nav-bar-height;
  width: 100%;
  height: 80px;
  display: none;
  align-items: center;
  z-index: 5;
  background: url("../../assets/images/home/settle-card-bg.png");
  background-size: center center;
  .cont-wrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      font-weight: 500;
      font-size: 30px;
      color: #0d1400;
      line-height: 28px;
    }
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 150px;
      height: 52px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 12px;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      line-height: 28px;
    }
  }
}
.about-us-page {
  background: #fff;
  min-width: 1200px;
  width: 100%;
  .header-wrap {
    height: 609px;
    background: url("../../assets/images/about/header-bg.png");
    background-position: top center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  ::v-deep .about-nav-bar {
    .nav-bar {
      background: rgba($color: #fff, $alpha: 0.4);
    }
  }
  ::v-deep .white-bg.about-nav-bar {
    .nav-bar {
      background: #fff;
    }
  }
  .top-cont {
    width: 1200px;
    margin: 0 auto;
    .intro {
      .title {
        display: flex;
        align-items: center;
        .join-btn {
          margin-left: 20px;
          border-radius: 12px;
          width: 140px;
          height: 50px;
          font-weight: 600;
          font-size: 20px;
          color: #ffffff;
          line-height: 22px;
          background: linear-gradient(135deg, #00eb81 0%, #00c89d 100%);
        }
      }
    }
  }
  //   介绍
  .intro {
    padding-top: 60px;
    padding-left: 30px;
    .title {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 36px;
      color: #0d1400;
      line-height: 32px;
      margin-bottom: 30px;
    }
    .info {
      width: 523px;
      font-weight: 400;
      font-size: 16px;
      color: #515350;
      line-height: 26px;
      margin-bottom: 60px;
    }
    .settle-in-btn {
      width: 140px;
      height: 50px;
      border-radius: 12px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
      line-height: 22px;
      margin-left: 20px;
    }
  }
  .info-list {
    display: flex;
    justify-content: space-between;
    .info-item {
      position: relative;
      width: 580px;
      height: 240px;
      background: linear-gradient(
        135deg,
        #f4fff8 0%,
        #fefeff 87%,
        #f9fbff 100%
      );
      border-radius: 24px;
      border: 2px solid #ffffff;
      backdrop-filter: blur(10px);
      padding: 27px 23px 0 34px;
      overflow: hidden;
      .index {
        display: inline-block;
        font-weight: 600;
        font-size: 30px;
        line-height: 32px;
        margin-bottom: 17px;
        color: rgba($color: #00c89d, $alpha: 0.2);
      }
      .title {
        font-weight: 500;
        font-size: 24px;
        color: #0d1400;
        line-height: 32px;
        margin-bottom: 20px;
      }
      .text {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 26px;
      }
    }
    .info-item::after {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      content: "";
      width: 80px;
      height: 80px;
      background: url("../../assets/images/about/logo-bg.png");
      background-size: 100% 100%;
    }
  }

  .class-features {
    padding: 60px 0 50px;
    width: 1200px;
    margin: 0 auto;
    .title {
      font-weight: 500;
      font-size: 36px;
      color: #0d1400;
      line-height: 32px;
      text-align: center;
      margin-bottom: 60px;
    }
    .cont-wrap {
      display: flex;
      justify-content: space-between;
    }
    .tab-list {
      margin-right: 31px;
    }
    .tab-item {
      transition: all 0.3s ease;
      cursor: pointer;
      padding: 30px 43px 0 40px;
      width: 380px;
      height: 167px;
      background: #ebfff7;
      border-radius: 24px;
      border: 2px solid #cdffe8;
      margin-bottom: 20px;
      .tab-name {
        font-weight: 600;
        font-size: 28px;
        color: #0d1400;
        line-height: 40px;
        margin-bottom: 13px;
      }
      .tab-info {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
    }
    .tab-item:last-child {
      margin-bottom: 0;
    }
    .is-active {
      background: linear-gradient(180deg, #00eb81 0%, #00c89d 100%);
      border: 2px solid #ffffff;
      .tab-name,
      .tab-info {
        color: #fff;
      }
    }
  }

  .ai-cont {
    height: 510px;
    background: url("../../assets/images/about/ai-bg.png");
    background-size: 100% 100%;
    .cont-wrap {
      width: 1200px;
      margin: 0 auto;
    }
    .title {
      font-weight: 500;
      font-size: 36px;
      color: #ffffff;
      line-height: 32px;
      padding: 80px 0;
      text-align: center;
    }
    .info-wrap {
      display: flex;
      justify-content: space-between;
    }
    .info-item {
      width: 360px;
      height: 240px;
      background: url("../../assets/images/about/ai-item-bg.png");
      background-size: 100% 100%;
      padding: 28px 34px 0 30px;
      .icon {
        width: 48px;
        height: 48px;
        margin-bottom: 14px;
      }
      .name {
        font-weight: 600;
        font-size: 28px;
        color: #ffffff;
        line-height: 40px;
        margin-bottom: 15px;
      }
      .info {
        font-weight: 400;
        font-size: 16px;
        color: rgba($color: #fff, $alpha: 0.8);
        line-height: 22px;
      }
    }
  }

  .user-cont {
    // height: 610px;
    background: linear-gradient(
      180deg,
      rgba($color: #e3f8eb, $alpha: 0.3) 0%,
      rgba($color: #e3f8eb, $alpha: 0.3) 100%
    );
    .cont-wrap {
      width: 1200px;
      margin: 0 auto;
    }
    .title {
      font-weight: 500;
      font-size: 36px;
      color: #0d1400;
      line-height: 32px;
      padding: 70px 0 50px;
      text-align: center;
    }
    .user-list {
      display: flex;
      // justify-content: space-between;
    }
    .user-item {
      margin-bottom: 40px;
      position: relative;
      cursor: pointer;
      width: 360px;
      height: 429px;
      margin-right: 50px;
      background: linear-gradient(
        135deg,
        #f4fff8 0%,
        #fefeff 87%,
        #f9fbff 100%
      );
      border-radius: 24px;
      border: 2px solid #ffffff;
      overflow: hidden;
      img {
        width: 360px;
        height: 240px;
      }
      .name {
        padding: 23px 0 0 30px;
        font-weight: 600;
        font-size: 28px;
        color: #0d1400;
        line-height: 40px;
      }
      .info {
        padding: 4px 38px 0 30px;
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
      .join-btn {
        width: 300px;
        height: 50px;
        border-radius: 12px;
        margin: 15px 0 30px 30px;
        background: linear-gradient(135deg, #00eb81 0%, #00c89d 100%);
        font-weight: 600;
        font-size: 20px;
        color: #ffffff;
        line-height: 22px;
      }
    }
    .join-btn {
      width: 300px;
      height: 50px;
      font-weight: 600;
      font-size: 20px;
      border-radius: 12px;
      color: #ffffff;
      line-height: 22px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      margin: 15px 30px 0 30px;
    }
    // .hover-btn-wrap {
    //   transition: all 0.2s ease;
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: 360px;
    //   height: 243px;
    //   background: linear-gradient(
    //     135deg,
    //     rgba($color: #ffffff, $alpha: 0.4) 0%,
    //     rgba($color: #3dffd5, $alpha: 0.4) 100%
    //   );
    //   border-radius: 24px 24px 0 0;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   opacity: 0;
    //   button {
    //     width: 170px;
    //     height: 50px;
    //     font-weight: 600;
    //     font-size: 20px;
    //     border-radius: 12px;
    //     color: #ffffff;
    //     line-height: 50px;
    //     text-align: center;
    //     background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    //   }
    // }
    // .user-item:hover {
    //   .hover-btn-wrap {
    //     transition: all 0.2s ease;
    //     opacity: 1;
    //   }
    // }
  }

  .img-wrap {
    width: 794px;
    height: 541px;
    scroll-snap-type: x mandatory;
    overflow-y: scroll;
    overflow-x: hidden;
    scroll-behavior: smooth;
    scrollbar-width: 0;
    /* 标准语法，Firefox 支持 */
    -ms-overflow-style: none;
    pointer-events: none;
    /* IE 和 Edge */
    &::-webkit-scrollbar {
      display: none;
      /* WebKit 内核浏览器 */
    }
    img {
      width: 794px;
      height: 541px;
    }
  }
}
</style>
